/** 奖品排序 */
export const awards_sort = (awards) => {
	let next_awards = [...awards];

	next_awards.sort((a, b) => {
		if (a.class === b.class) {
			return b.awardPrice - a.awardPrice;
		}


		return (
			a.class > b.class
		) ? -1 : 1;
	});


	return next_awards;
};
